module.exports = __webpack_public_path__ + "static/media/AppPromotion.bf8d25cc.jpg";